import Reveal from './Reveal';
import product1400 from '@/assets/home-right-1400.webp.asset.json';
import product700 from '@/assets/home-right-700.webp.asset.json';

/**
 * The "is this real?" beat. It sits directly after How it works, at the moment
 * the visitor has understood the loop and starts asking whether the product
 * actually exists. One screenshot, one line of copy, no feature bullets — the
 * real photos, real prices and real lab numbers inside the image do the work.
 */
const ProductProof = () => (
  <section className="border-b border-border bg-subtle py-20 md:py-24">
    <div className="container-wide">
      <Reveal className="max-w-2xl">
        <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl">
          This is what your buyers open
        </h2>
        <p className="mt-4 text-lg text-muted-foreground">
          A live menu with current pricing, lab results and real photos of the listing — on a
          laptop or a phone, without a login wall to look.
        </p>
      </Reveal>

      <Reveal delay={120} className="mt-12">
        <img
          src={product1400.url}
          srcSet={`${product700.url} 700w, ${product1400.url} 1400w`}
          sizes="(min-width: 1024px) 1000px, 92vw"
          width={1400}
          height={1138}
          loading="lazy"
          decoding="async"
          alt="A Cannafax supplier menu open on desktop and phone, showing listings with photos, quantities, THC and terpene percentages, tests-passed badges, per-gram pricing and an I'm Interested button, alongside a share-link dialog."
          className="mx-auto w-full max-w-5xl"
        />
      </Reveal>
    </div>
  </section>
);

export default ProductProof;